import { useCommonWebsocketEventListener } from "../../hooks/use-common-websocket-event-listener";

export const CommonWebsocketEventListenerProvider = () => {
  useCommonWebsocketEventListener();

  return <></>;
};
